import { useReveal } from "@/hooks/useReveal";

const CHANNELS = [
  {
    title: "Organic distributors & health food",
    bullets: [
      "Territory exclusivity available",
      "Retail-ready packs and point-of-sale material",
      "Full brand story and traceability",
    ],
    link: "See distributor terms",
  },
  {
    title: "Private label & co-packing",
    bullets: [
      "Low minimum order quantities",
      "Certified plant, so your product keeps its organic claim",
      "A complete supermarket range developed in under four months",
    ],
    link: "See how private label works",
  },
  {
    title: "Food manufacturers & ingredients",
    bullets: [
      "Stable granulometry, moisture and polarisation",
      "Certificate of analysis per batch",
      "Organic certification that holds up in EU and US destinations",
    ],
    link: "See technical specifications",
  },
  {
    title: "Coffee shops & hospitality",
    bullets: [
      "Organic cane sugar sachets for the counter",
      "Cocoa powder for beverage preparation",
      "We are happy to supply through your local foodservice distributor",
    ],
    link: "Request counter samples",
  },
];

export default function Channels() {
  const headingRef = useReveal<HTMLDivElement>();
  const gridRef = useReveal<HTMLDivElement>();

  return (
    <section id="channels" className="bg-ink py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={headingRef} className="reveal">
          <h2 className="text-cream font-serif text-3xl md:text-4xl font-semibold">
            Tell us how you buy
          </h2>
          <p className="mt-4 text-cream/70 text-lg max-w-2xl">
            Each of these has a different specification sheet, a different
            minimum and a different conversation. Choose the one that describes
            you.
          </p>
        </div>

        <div ref={gridRef} className="reveal mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {CHANNELS.map((channel) => (
            <a
              key={channel.title}
              href="#quote"
              className="group block rounded-lg bg-ink-soft border border-cream/10 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-brand/40"
            >
              <h3 className="text-cream font-serif text-xl font-semibold">
                {channel.title}
              </h3>
              <ul className="mt-5 space-y-3">
                {channel.bullets.map((bullet) => (
                  <li key={bullet} className="flex items-start gap-3 text-cream/80 text-base">
                    <i className="ri-check-line text-brand mt-0.5 text-lg"></i>
                    <span className="leading-snug">{bullet}</span>
                  </li>
                ))}
              </ul>
              <span className="mt-6 inline-flex items-center gap-2 text-brand text-base font-semibold">
                {channel.link}
                <i className="ri-arrow-right-line text-lg transition-transform duration-300 group-hover:translate-x-1.5"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}